import React, { FC, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useTheme } from "@mui/material/styles";
import {
  CalendarScheduleList,
  ScheduleData,
} from "../../interface/schedule";
import ModalContainer from "../UIElements/modal-container";
import { Box, Button, Stack } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import ScheduleDetailsInfo from "./ScheduleDetailsInfo";

const localizer = momentLocalizer(moment);

const CustomCalendar: FC<CalendarScheduleList> = ({
  scheduleList,
  setRefresh,
}) => {
  const isSmall = useResponsive("down", "sm", "xl");
  const theme = useTheme();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  

  // Convert schedules to calendar events
  const calendarItems = scheduleList?.map((schedule: ScheduleData) => ({
    _id: schedule._id,
    title: schedule.schedule_name,
    shifts: Array.isArray(schedule.shifts) ? schedule.shifts : [],
    start: new Date(schedule.start_date),
    end: new Date(schedule.end_date),
    description: schedule.description,
    status: schedule.status,
    facility: schedule.facility,
    type: "schedule",
  }));

  const handleSelectItem = (item: any) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };

  // Custom event styling
  const eventStyleGetter = (event: any) => {
    let style = {
      backgroundColor: "#34a853",
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "none",
      display: "block",
      fontFamily: "Roboto",
    };

    if (event.status === "draft") {
      style.backgroundColor = "#6881C8";
      style.fontFamily = "DM Sans";
    }
    return { style };
  };

  // Custom event component to display more information
  const EventComponent = ({ event }: { event: any }) => (
    <div>
      <strong>{event.title}</strong>
      <br />
      <span>Shifts: {event.shifts.length}</span>
    </div>
  );

  const handleAddShift = (values: any) => {
    // const newShift: Shift = {
    //   _id: Date.now().toString(),
    //   employee_id: values.title,
    //   start_time: values.dateRange[0].toDate(),
    //   end_time: values.dateRange[1].toDate(),
    // };
    // setShifts([...shifts, newShift]);
    // closeModal();
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={[...calendarItems]}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500, fontFamily: "Lexend" }}
        onSelectEvent={handleSelectItem}
        eventPropGetter={eventStyleGetter}
        components={{
          event: EventComponent,
        }}
      />
      <ModalContainer
        sx={{}}
        size={"md"}
        openModal={isModalOpen}
        fullWidth={true}
        handleModal={closeModal}
      >
        <Box sx={{ background: "white", p: 2 }}>
          {selectedItem && (
            <ScheduleDetailsInfo
              mode={"Grid"}
              closeModal={closeModal}
              setRefresh={setRefresh}
              scheduleInfo={selectedItem}
            />
          )}
          <Stack direction="row" justifyContent={"flex-end"} sx={{ mx: 3 }}>
            <Button
              variant="contained"
              sx={{ fontWeight: "bold", marginLeft: "auto" }}
              onClick={closeModal}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </ModalContainer>
    </div>
  );
};

export default CustomCalendar;
